import { render, staticRenderFns } from "./MedicalDevicesHistory.vue?vue&type=template&id=0028b4ed"
import script from "./MedicalDevicesHistory.vue?vue&type=script&lang=js"
export * from "./MedicalDevicesHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports